import axios from 'axios'

const DEV_MODE = import.meta.env.VITE_APP_MODE === 'development'
const systemId = import.meta.env.VITE_APP_SYSTEMID

export const useApiClient = () => {
  const get3 = (url) => {
    return axios
      .get(url)
      .then((response) => response)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }

  const get = (url, params) => {
    // DEV_MODE && console.log('params')
    // DEV_MODE && console.log(params)
    const queryParams = params ? new URLSearchParams(params) : {}
    queryParams.append('systemId', systemId)

    return axios
      .get(url, { params: queryParams })
      .then((response) => response)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }

  const get2 = (url, params) => {
    params.systemId = systemId
    return axios
      .get(url, { params })
      .then((response) => response)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }

  /**
   * 배열 파라미터를 반복 query(`key=a&key=b`)로 직렬화하는 GET.
   * - axios 기본 직렬화(`key[]=a`)나 URLSearchParams(`key=a,b`)와 달리 동일 key를 반복 append.
   * - null/undefined 값은 query에서 제외 (선택 파라미터 대응).
   * - 예: { analysisTypeIds: [3, 4] } → `analysisTypeIds=3&analysisTypeIds=4`
   */
  const getList = (url, params) => {
    const queryParams = new URLSearchParams()
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return
        if (Array.isArray(value)) {
          value.forEach((v) => queryParams.append(key, v))
        } else {
          queryParams.append(key, value)
        }
      })
    }
    queryParams.append('systemId', systemId)

    return axios
      .get(url, { params: queryParams })
      .then((response) => response)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }

  const post = async (url, data) => {
    return await axios
      .post(url, { ...data, systemId })
      .then((response) => response.data)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }
  const post2 = async (url, data) => {
    return await axios
      .post(url, { ...data, systemId })
      .then((response) => response)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }

  const put = (url, data) => {
    return axios
      .put(url, { ...data, systemId })
      .then((response) => response.data)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }

  const patch = (url, data) => {
    return axios
      .patch(url, data, { params: { systemId } })
      .then((response) => response.data)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }

  const deleteRequest = (url, params) => {
    const queryParams = new URLSearchParams()
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(v => queryParams.append(key, v))
        } else {
          queryParams.append(key, value)
        }
      })
    }
    queryParams.append('systemId', systemId)

    return axios
      .delete(url, { params: queryParams })
      .then((response) => response.data)
      .catch((error) => {
        console.error(error)
        throw error
      })
  }

  return { get, get2, getList, put, patch, post, post2, del: deleteRequest, get3 }
}
